export default __webpack_public_path__ + "static/media/image18.716204b8.png";